import React from "react";
import { Row, Col } from "reactstrap";
import "../begin-questionnaire/begin-questionnaire.css";
import Renderinputrange from "./input-range";
import { Renderoptionnames } from "./option-name";
import { Button } from "reactstrap";
import Renderquestions from "./question-wrapper";
import Renderassessmentmodal from "../begin-questionnaire/submit-assessment-modal/index";
import Rendermodals from "../../Modals/modal";
import Rendersuccessmodal from "../begin-questionnaire/submit-assessment-modal/success-modal";
import info_black_24dp from "../../../../images/info_black_24dp.png";
import Popover from "../../PopOver/Popover";
import RenderReviewPopOver from "./reviewPopOver";

const Renderassessmentquestions = ({
  myAssessmentIcon,
  text,
  reviewText,
  defaultQuestionNumber,
  handleQuestionNumber,
  handleInputRange,
  defaultColor,
  handleAssessmentSubmit,
  assessmentModal,
  handleModalClose,
  handleModalSubmit,
  nestedModal,
  values,
  value,
  reviewMode,
  handleReviewAssessment,
  isPopOverVisible,
  overlayIsVisible,
  handleReviewPopOver,
  handleCloseReviewPopOver,
  handleReviewAssessmentSubmit,
  handleSaveAndContinue,
  touched,
  questionNumber,
  questionList,
  instrumentOptions,
  runningQuestionId,
  instrumentType,
  assessmentType,
  invitationDetails,
  participant_gender,
  participantId,
  uid,
  isMultiRater,
  min_batch_respondents,
  myRef
}) => {
  const maxValue =
    instrumentOptions && instrumentOptions.length
      ? instrumentOptions[instrumentOptions.length - 1].option_end_value
      : 0;
  const arrIndex = questionNumber.map((i, index) => {
    return index;
  });
  const arrLength = arrIndex.length;
  return (
    <React.Fragment>
      <Row>
        <Col md="10">
          <div className="heading-wrapper">
            <img src={myAssessmentIcon} />
            <h1>
              {reviewMode === false ? text : reviewText}
              {reviewMode === false ? (
                <span></span>
              ) : (
                <span>
                  <Popover
                    className="Invitation-popover"
                    positions={["right", "bottom"]}
                    align={"center"}
                    targtElement={<img src={info_black_24dp} alt="info icon" />}
                    isOpen={isPopOverVisible}
                    setOpen={handleReviewPopOver}
                  >
                    <RenderReviewPopOver
                      handleCloseReviewPopOver={handleCloseReviewPopOver}
                    />
                  </Popover>
                </span>
              )}
            </h1>
          </div>
          {overlayIsVisible && <div className="overlay"></div>}
        </Col>
        <Col md="2">
          <div className="counter-wrapper">
            <p>Question</p>
            <ul>
              {defaultQuestionNumber === arrLength ? (
                <li style={{ color: "#1a5985" }}>{defaultQuestionNumber}</li>
              ) : (
                <li>{defaultQuestionNumber}</li>
              )}
              <li>{arrLength}</li>
            </ul>
          </div>
        </Col>
      </Row>
      <Renderquestions
        defaultQuestionNumber={defaultQuestionNumber}
        handleQuestionNumber={handleQuestionNumber}
        reviewMode={reviewMode}
        values={values}
        questionNumber={questionNumber}
        questionList={questionList}
        instrumentOptions={instrumentOptions}
        runningQuestionId={runningQuestionId}
        assessmentType={assessmentType}
        invitationDetails={invitationDetails}
        participant_gender={participant_gender}
        myRef={myRef}
      />
      <Renderinputrange
        value={parseFloat(value || maxValue / 2)}
        handleInputRange={handleInputRange}
        instrumentOptions={instrumentOptions}
        touched={Boolean(values[defaultQuestionNumber])}
        questionList={questionList}
        instrumentType={instrumentType}
      />

      <Renderoptionnames
        value={parseFloat(value || maxValue / 2)}
        defaultColor={defaultColor}
        touched={Boolean(values[defaultQuestionNumber])}
        instrumentOptions={instrumentOptions}
        questionList={questionList}
      />
      {reviewMode === false ? (
        <div className="question-button-wrapper">
          <Button
            onClick={!touched ? null : handleAssessmentSubmit}
            className={
              values[defaultQuestionNumber]
                ? "button-active"
                : "button-disabled"
            }
          >
            {defaultQuestionNumber === questionNumber.length
              ? "Submit"
              : "Next"}
          </Button>
        </div>
      ) : (
        <div className="review-button-wrapper">
          {defaultQuestionNumber === questionNumber.length ? null : (
            <Button type="submit" onClick={handleSaveAndContinue}>
              Save and Continue
            </Button>
          )}
          <Button onClick={handleReviewAssessmentSubmit}>Submit</Button>
        </div>
      )}

      <Rendermodals
        assessmentModal={assessmentModal}
        modalHeading="SUBMIT ASSESSMENT"
        button1="Yes,Review"
        button2="Submit"
        modalConfirmation="Are you sure?"
        modalText="Would you like to review before submitting the assessment?"
        handleModalClose={handleModalClose}
        handleModalSubmit={handleModalSubmit}
      >
        <Renderassessmentmodal
          modalConfirmation="Are you sure?"
          modalText="Would you like to review before submitting the assessment?"
          button1="Yes, Review"
          button2="SUBMIT"
          handleReviewAssessment={handleReviewAssessment}
          handleModalSubmit={handleModalSubmit}
        />
        {assessmentType == "invitations" ? (
          <Rendersuccessmodal
            nestedModal={nestedModal}
            submitButtonText="NEXT"
            modalSuccessMessage="Hooray!"
            modalText={`You have successfully completed assessing ${invitationDetails.user_assessment__participant__full_name}`}
            uid={uid}
            assessmentType={assessmentType}
            invitationDetails={invitationDetails}
            participantId={participantId}
            isMultiRater={isMultiRater}
          />
        ) : (
          <Rendersuccessmodal
            nestedModal={nestedModal}
            submitButtonText="NEXT"
            modalSuccessMessage="Hooray!"
            modalText=" You have successfully completed assessing yourself"
            requestText={
              isMultiRater == false
                ? ""
                : "Next, request people who know you well to assess you and submit your LOI"
            }
            uid={uid}
            assessmentType={assessmentType}
            invitationDetails={invitationDetails}
            participantId={participantId}
            isMultiRater={isMultiRater}
            instrumentType={instrumentType}
            min_batch_respondents={min_batch_respondents}
          />
        )}
      </Rendermodals>
      {reviewMode == true &&
        (assessmentType == "invitations" ? (
          <Rendersuccessmodal
            nestedModal={nestedModal}
            submitButtonText="NEXT"
            modalSuccessMessage="Hooray!"
            modalText={`You have successfully completed assessing ${invitationDetails.user_assessment__participant__full_name}`}
            uid={uid}
            assessmentType={assessmentType}
            invitationDetails={invitationDetails}
            participantId={participantId}
            isMultiRater={isMultiRater}
            reviewMode={reviewMode}
          />
        ) : (
          <Rendersuccessmodal
            nestedModal={nestedModal}
            submitButtonText="NEXT"
            modalSuccessMessage="Hooray!"
            modalText=" You have successfully completed assessing yourself"
            uid={uid}
            assessmentType={assessmentType}
            invitationDetails={invitationDetails}
            participantId={participantId}
            isMultiRater={isMultiRater}
            reviewMode={reviewMode}
            min_batch_respondents={min_batch_respondents}
          />
        ))}
    </React.Fragment>
  );
};

export default Renderassessmentquestions;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/questions.jsx